import { getCookie } from './functions'


jQuery(document).ready(function($){

	

	var disani = getCookie('disani');

	

	var is_rtl = $('body').hasClass('rtl');

	

	$('.widget-slider').each(function(){

		

		var slider_wrap = $(this);

		var slider = $(slider_wrap).find('.slider > div');

		var arrows = $(slider_wrap).find('.arrows');

		var next_slide = $(arrows).find('.next-slide');

		var prev_slide = $(arrows).find('.prev-slide');

		var slidesToShow = $(slider_wrap).attr('slides-to-show');

		var slidesToScroll = $(slider_wrap).attr('slides-to-scroll');

		var autoplay = $(slider_wrap).attr('autoplay');

		var fade = $(slider_wrap).attr('fade');

		var autoplaySpeed = $(slider_wrap).attr('autoplaySpeed');

		var is_tabs = $(slider_wrap).hasClass('tabs');

		var num_of_posts = $(slider_wrap).attr('num-of-posts');

		

		var is_vertical = $(slider_wrap).hasClass('vertical') ? true : false;		

		

		var sts1600 = slidesToShow

		var sts1200 = slidesToShow;

		var sts992 = slidesToShow;

		var sts768 = slidesToShow;

		var sts480 = slidesToShow;

		

		if( slider_wrap.parent().hasClass('full-width') ){

			sts992 = 3;

			sts768 = 2;

			sts480 = 1;

		}

		

		if( slider_wrap.hasClass('adds') || slider_wrap.hasClass('tabs') ){

			sts1600 = 1;

			sts1200 = 1;

			sts992 = 1;

			sts768 = 1;

			sts480 = 1;

		}

		

		// partners slider

		if(slidesToShow == 9){

			sts1600 = 7;

			sts1200 = 5;

			sts992 = 4;

			sts768 = 3;

			sts480 = 3;

		}

		

		// full slider

		if(slidesToShow == 7){

			sts1600 = 6;

			sts1200 = 5;

			sts992 = 4;

			sts768 = 3;

			sts480 = 2;

		}

		

		if(slidesToShow <= 3){

			sts480 = 1;

		}

		

		if(num_of_posts == 2 && slidesToShow == 2){

			sts1600 = 2;

			sts1200 = 2;

			sts992 = 2;

			sts768 = 2;

		}

		

		if( disani == 'active' ){

			autoplay = false;

		}

		

		slider.slick({

			slidesToShow: slidesToShow ? slidesToShow : 2,

			slidesToScroll: slidesToScroll ? slidesToScroll : 1,

			arrows: false,

			dots: false,

			infinite: true,

			focusOnSelect: true,

			fade: fade ? true : false,

			vertical: is_vertical,

			autoplay: autoplay ? true : false,

			accessibility: true,

			adaptiveHeight: true,

			autoplaySpeed: autoplaySpeed ? autoplaySpeed : 3000,

			responsive: [

				{

					breakpoint: 1600,

					settings: {

						slidesToShow: sts1600,

					}

				},

				{

					breakpoint: 1200,

					settings: {

						slidesToShow: sts1200,

					}

				},

				{

					breakpoint: 992,

					settings: {

						slidesToShow: sts992,

					}

				},

				{

					breakpoint: 768,

					settings: {

						slidesToShow: sts768,

					}

				},

				{

					breakpoint: 480,

					settings: {

						slidesToShow: sts480,

					}

				}

			]

		});

		

		$('a.toggle-btn[data-acc="disani"]').click( function(){

			if( !$(this).hasClass('active') ){

				slider.slick('slickPause');

			}

		});

		

		$(next_slide).on('click', function() {

			$(slider).slick('slickNext');

		});

		

		$(prev_slide).on('click', function() {

			$(slider).slick('slickPrev');

		});

		

		$(slider_wrap).find('.tabs-nav').each(function() {

			var nav = $(this);

			$(nav).find('a').click( function() {

				var tab_num = $(this).index();

				$(nav).find('a').removeClass('active');

				$(this).addClass('active');

				

				$(slider).slick('slickGoTo',tab_num,false);

			});

		});

		

	});

	

	var cover_autoplay = true;

	if( disani == 'active' ){

		cover_autoplay = false;

	}

	

	$('.cover.slider').slick({

		slidesToShow: 1,

		slidesToScroll: 1,

		arrows: false,

		dots: false,

		infinite: true,

		focusOnSelect: true,

		fade: true,

		autoplay: cover_autoplay,

		accessibility: true

	});

	

	$('a.toggle-btn[data-acc="disani"]').click( function(){

		if( !$(this).hasClass('active') ){

			$('.cover.slider').slick('slickPause');

		}

	});

	

});